import { render, staticRenderFns } from "./GoldStoneClassifyManageList.vue?vue&type=template&id=346cba89&scoped=true&"
import script from "./GoldStoneClassifyManageList.vue?vue&type=script&lang=js&"
export * from "./GoldStoneClassifyManageList.vue?vue&type=script&lang=js&"
import style0 from "./GoldStoneClassifyManageList.vue?vue&type=style&index=0&id=346cba89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346cba89",
  null
  
)

export default component.exports